import { TravelerFormSearchFormDataType } from "../../../../../components/list/FormSearch/modals"
import { TravelersListPostType } from "../../../../../models/list"

const getValueWorkplace = (
  workPlaceLocation?: number | string,
  value?: string,
) => (workPlaceLocation === 1 ? value : "")

export const convertDataSearch = (
  isFromSCR114UserSearch: boolean,
  values?: TravelerFormSearchFormDataType,
): TravelersListPostType => ({
  accompanies: {},
  base: {
    bumonCd: values?.bumonCd,
    dispatchTypeDetailId: values?.dispatchTypeDetailId,
  },
  detail: {
    workPlace: getValueWorkplace(values?.workPlaceLocation, values?.workPlace),
    workPlaceCity: getValueWorkplace(
      values?.workPlaceLocation,
      values?.workPlaceCity,
    ),
    workPlaceCountry: getValueWorkplace(
      values?.workPlaceLocation,
      values?.workPlaceCountry,
    ),
    workPlaceLocation: values?.workPlaceLocation,
  },
  fullName: values?.fullName,
  isFromSCR114UserSearch,
  isGetAllData: true,
})
